import { type IAIInteractionMessageDisplay } from '~types'

const DEFAULT_CHAT_PERSISTENCE_MINUTES = 15

export interface PersistedChatData {
  messages: IAIInteractionMessageDisplay[]
  timestamp: number
  aiInteractionId?: string
  userId?: string
}

export const getChatStorageKey = (organizationId: string): string => `poli_chat_${organizationId}`

export const getChatPersistenceTTLMinutes = (
  chatPersistenceMinutes?: number | null,
): number | null => {
  if (chatPersistenceMinutes === -1) return null
  return chatPersistenceMinutes ?? DEFAULT_CHAT_PERSISTENCE_MINUTES
}

export const rehydrateMessages = (
  messages: IAIInteractionMessageDisplay[],
): IAIInteractionMessageDisplay[] =>
  messages.map((msg) => ({
    ...msg,
    timestamp: new Date(msg.timestamp),
  }))

const getPersistedChat = (organizationId: string): PersistedChatData | null => {
  try {
    const data = localStorage.getItem(getChatStorageKey(organizationId))
    if (!data) return null
    const parsed = JSON.parse(data) as PersistedChatData
    return {
      ...parsed,
      messages: rehydrateMessages(parsed.messages),
    }
  } catch {
    return null
  }
}

export const getValidPersistedChat = (
  organizationId: string,
  chatPersistenceMinutes?: number | null,
): PersistedChatData | null => {
  const ttlMinutes = getChatPersistenceTTLMinutes(chatPersistenceMinutes)
  if (ttlMinutes === null) return null

  const persisted = getPersistedChat(organizationId)
  if (!persisted || persisted.messages.length === 0) return null

  const isWithinTTL = Date.now() - persisted.timestamp < ttlMinutes * 60 * 1000
  return isWithinTTL ? persisted : null
}
